var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_outline_clock",
    "data-name": "vuesax/outline/clock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75,19.5A9.75,9.75,0,1,1,19.5,9.75,9.758,9.758,0,0,1,9.75,19.5Zm0-18.14a8.39,8.39,0,1,0,8.39,8.39A8.4,8.4,0,0,0,9.75,1.36Z",
    transform: "translate(1.25 1.25)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H22V22H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.41,6a.755.755,0,0,1-.75-.75V5.04A2.327,2.327,0,0,1,2.83,3.09c.37-.25.49-.42.49-.68a.91.91,0,1,0-1.82,0,.755.755,0,0,1-.75.75A.755.755,0,0,1,0,2.41a2.41,2.41,0,1,1,4.82,0A2.294,2.294,0,0,1,3.67,4.33c-.39.26-.51.43-.51.71v.21A.749.749,0,0,1,2.41,6Z",
    transform: "translate(8.59 6.755)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.75,1.5A.75.75,0,1,1,1.5.75.749.749,0,0,1,.75,1.5Z",
    transform: "translate(10.25 13.745)",
    fill: "#c32bd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a1aa98c6606a9fd52614cfeb6dd0d53d.svg";
export { ForwardRef as ReactComponent };